import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export default function WorkloadBalancingTab({ analytics }) {
  return (
    <div data-testid="workload-balancing-tab">
      <h1 className="text-3xl font-bold text-slate-900 mb-6">Workload Balancing</h1>
      <Card>
        <CardHeader><CardTitle>Team Member Workload</CardTitle></CardHeader>
        <CardContent>
          {analytics?.agent_stats ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Team Member</TableHead>
                  <TableHead>Assigned</TableHead>
                  <TableHead>Completed</TableHead>
                  <TableHead>Pending</TableHead>
                  <TableHead>Workload Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {Object.entries(analytics.agent_stats).map(([name, data]) => {
                  const pending = (data.assigned || 0) - (data.completed || 0);
                  const status = pending > 10 ? 'overloaded' : pending > 5 ? 'busy' : 'available';
                  return (
                    <TableRow key={name}>
                      <TableCell className="font-medium">{name}</TableCell>
                      <TableCell>{data.assigned || 0}</TableCell>
                      <TableCell className="text-green-600">{data.completed || 0}</TableCell>
                      <TableCell className="text-amber-600">{pending}</TableCell>
                      <TableCell>
                        <Badge className={
                          status === 'overloaded' ? 'bg-red-100 text-red-700' :
                          status === 'busy' ? 'bg-amber-100 text-amber-700' :
                          'bg-green-100 text-green-700'
                        }>
                          {status === 'overloaded' ? 'Overloaded' : status === 'busy' ? 'Busy' : 'Available'}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <p className="text-slate-500 text-center py-8">No workload data available</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
